module.exports = __webpack_public_path__ + "static/media/aa6.44bbd88d.jpg";